
export const environment = {
  production: false,
  serverUrl: "https://my-json-server.typicode.com/emreozbek/chat-db/",
  userId: 0
};
